import { SystemDescriptions } from "src/common/descriptions";
import { formatToCurrency } from "src/common/util";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.SERVICE.SERVICES
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    NAME = 'name',
    PRICE = 'price',
    IS_MONTHLY = 'isMonthly',
    CATEGORY = 'serviceCategory',
    IS_ACTIVE = 'isActive',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.NAME,
        dataIndex: ColumnsKeys.NAME,
        key: ColumnsKeys.NAME,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.PRICE,
        dataIndex: ColumnsKeys.PRICE,
        key: ColumnsKeys.PRICE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.IS_MONTHLY,
        dataIndex: ColumnsKeys.IS_MONTHLY,
        key: ColumnsKeys.IS_MONTHLY,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? "Si" : "No"
    },
    {
        title: descriptions.TABLE_COLUMNS.CATEGORY,
        dataIndex: ColumnsKeys.CATEGORY,
        key: ColumnsKeys.CATEGORY,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.IS_ACTIVE,
        key: ColumnsKeys.IS_ACTIVE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? commonDescriptions.ACTIVE_STATUS : commonDescriptions.INACTIVE_STATUS
    },
];